module.exports = __webpack_public_path__ + "img/chokorin3.e28373e5.png";